import { useEffect, type ReactNode } from "react";
import "../../styles/login-dialog.css";

/** The frosted card used by the login page's popups and the reset page. */
export function LoginDialog({ title, intro, onClose, children }: { title: string; intro?: ReactNode; onClose?: () => void; children: ReactNode }) {
  useEffect(() => {
    if (!onClose) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="LoginDialog" onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="card" role="dialog" aria-modal="true" aria-label={title}>
        {onClose && (
          <button type="button" className="close" aria-label="Close" onClick={onClose}>
            ×
          </button>
        )}
        <h1>{title}</h1>
        {intro && <p>{intro}</p>}
        {children}
      </div>
    </div>
  );
}
